export default __webpack_public_path__ + "static/media/xem.87079f2e.svg";